var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 103,
    viewBox: "0 0 100 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.326 102.749L53.2528 74.5244H19.4961L36.5463 102.749H70.326Z",
    fill: "#003563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4547 28.2247L63.4045 0H29.625L46.6982 28.2247H80.4547Z",
    fill: "#003563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6766 28.2245L19.4972 74.5459C16.0483 74.545 12.6614 73.6276 9.68175 71.8872C6.7021 70.1469 4.23615 67.6458 2.5356 64.639C0.835036 61.6321 -0.0394137 58.2273 0.00136359 54.7713C0.042139 51.3154 0.996757 47.9321 2.76779 44.9664L29.6264 0L46.6766 28.2245Z",
    fill: "#2968A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3008 74.547L80.5032 28.2256C83.952 28.2265 87.3389 29.1439 90.3187 30.8843C93.2983 32.6246 95.7642 35.1259 97.4648 38.1326C99.1652 41.1394 100.04 44.5443 99.9988 48.0002C99.9581 51.4562 99.0036 54.8394 97.2325 57.8051L70.3509 102.772L53.3008 74.547Z",
    fill: "#2968A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4552 28.2256L53.2528 74.524H19.4961L46.6985 28.2256H80.4552Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/Tech.818f680b8b13d17574aa6dc33b54633f.svg";
export { ForwardRef as ReactComponent };